var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3922 14.0251L15.7172 16.6584C15.8005 17.3501 15.0589 17.8334 14.4672 17.4751L10.9755 15.4001C10.5922 15.4001 10.2172 15.3751 9.85053 15.3251C10.4672 14.6001 10.8339 13.6834 10.8339 12.6917C10.8339 10.3251 8.78386 8.40844 6.25052 8.40844C5.28386 8.40844 4.39219 8.68341 3.65053 9.16675C3.62553 8.95841 3.61719 8.75007 3.61719 8.53341C3.61719 4.74174 6.90886 1.66675 10.9755 1.66675C15.0422 1.66675 18.3339 4.74174 18.3339 8.53341C18.3339 10.7834 17.1755 12.7751 15.3922 14.0251Z",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8307 12.6917C10.8307 13.6834 10.4641 14.6001 9.8474 15.3251C9.0224 16.3251 7.71406 16.9667 6.2474 16.9667L4.0724 18.2584C3.70573 18.4834 3.23906 18.1751 3.28906 17.7501L3.49739 16.1084C2.38073 15.3334 1.66406 14.0917 1.66406 12.6917C1.66406 11.2251 2.4474 9.93342 3.6474 9.16676C4.38907 8.68342 5.28073 8.40845 6.2474 8.40845C8.78073 8.40845 10.8307 10.3251 10.8307 12.6917Z",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon_comment.6827e19e2be43841fa728c83a26a06e4.svg";
export { ForwardRef as ReactComponent };